import { fromJS, Map, Set } from 'immutable';

import {
  addReturnsFilter,
  removeReturnsFilter,
  clearReturnsFilters,
  clearReturnsFilter,
  deleteReturn,
  updateReturnsDateRange,
  setReturnsFilters,
  updateReturnsSortBy,
  clearReturnsSortBy,
  requestReturns,
  setReturnsListType,
  setNavNewReturn,
  setSearchValues,
  setRequestAnchor
} from './actions';

import { ALL_RETURNS } from './constants';

const defaultState = Map({
  isFetching: false,
  returnList: [],
  selectedReturnsFilters: Map({
    departmentNames: Set([]),
    returnStatus: Set([]),
    creditType: Set([])
  }),
  sort: { field: 'createTimestamp', order: 'DESC' },
  dateRange: { period: '24 months' },
  totalRecords: 0,
  returnsFilterOptions: [],
  navNewReturn: false,
  // NEW
  returnListV2: [],
  totalResources: {},
  requestAnchor: 0,
  searchValues: { searchKey: '', searchTerm: '' },
  returnsListType: ALL_RETURNS
});

export default function returns(state = defaultState, action) {
  const newState = fromJS(state);

  switch (action.type) {
    case requestReturns.event.start:
      return newState.set('isFetching', true);
    case requestReturns.event.success: {
      const { objects, pages, isInitialCall } = action.payload;
      return newState
        .set('returnListV2', isInitialCall ? objects : [...newState.get('returnListV2'), ...objects])
        .set('totalResources', pages.totalResources)
        .set('isFetching', false);
    }
    case requestReturns.event.error:
      return newState.set('isFetching', false).set('returnListV2', []);

    // case requestReturns.event.success:
    //   if (!newState.get('initialReturnsFilterOptions').length) {
    //     return newState.withMutations(state => {
    //       state
    //         .set('isFetching', false)
    //         .set('returnList', action.payload.returns)
    //         .set('totalRecords', action.payload.totalRecords);
    //     });
    //   }
    //   return newState.withMutations(state => {
    //     state
    //       .set('isFetching', false)
    //       .set('returnList', action.payload.returns)
    //       .set('totalRecords', action.payload.totalRecords);
    //   });
    // case requestReturns.event.error:
    //   return newState.withMutations(state => {
    //     state.set('isFetching', false).set('returnList', []);
    //   });

    case deleteReturn.event.success:
      return newState
        .set(
          'returnListV2',
          newState.get('returnListV2').filter(rtrn => rtrn.id !== action.payload.returnId)
        )
        .set('totalResources', newState.get('totalResources') - 1);

    case setReturnsFilters.type: {
      return newState.set('returnsFilterOptions', action.payload);
    }
    case addReturnsFilter.type:
      return newState.setIn(
        ['selectedReturnsFilters', action.payload.key],
        Set(newState.getIn(['selectedReturnsFilters', action.payload.key]).add(action.payload.value))
      );
    case removeReturnsFilter.type:
      return newState.setIn(
        ['selectedReturnsFilters', action.payload.key],
        Set(newState.getIn(['selectedReturnsFilters', action.payload.key]).delete(action.payload.value))
      );
    case clearReturnsFilters.type:
      return newState.set('selectedReturnsFilters', defaultState.get('selectedReturnsFilters')).set('requestAnchor', 0);
    case clearReturnsFilter.type:
      return newState.setIn(['selectedReturnsFilters', action.payload], Set([]));

    case updateReturnsDateRange.type:
      return newState.set('dateRange', action.payload).set('requestAnchor', 0);
    case updateReturnsSortBy.type:
      return newState.set('sort', action.payload);
    case clearReturnsSortBy.type:
      return newState.set('sort', defaultState.get('sort'));

    case setReturnsListType.type:
      return newState.set('returnsListType', action.payload).set('requestAnchor', 0);

    case setNavNewReturn.type:
      return newState.set('navNewReturn', action.payload);

    case setSearchValues.type:
      return newState.set('searchValues', action.payload).set('requestAnchor', 0);

    case setRequestAnchor.type:
      return newState.set('requestAnchor', action.payload);

    default:
      return newState;
  }
}

export const returnList = state => state.returns.get('returnList');

export const isFetching = state => state.returns.get('isFetching');
export const selectedFilters = state => state.returns.get('selectedReturnsFilters');
export const dateRange = state => state.returns.get('dateRange');
export const filterOptions = state => state.returns.get('returnsFilterOptions');
export const sortBy = state => state.returns.get('sort');
export const getReturnsListType = state => state.returns.get('returnsListType');
export const totalRecords = state => state.returns.get('totalRecords');

export const navNewReturn = state => state.returns.get('navNewReturn');

// NEW
export const getReturnListV2 = state => state.returns.get('returnListV2');
export const getTotalResources = state => state.returns.get('totalResources');
export const getIsFetching = state => state.returns.get('isFetching');
export const getRequestAnchor = state => state.returns.get('requestAnchor');
export const getFilterOptions = state => state.returns.get('returnsFilterOptions');
export const getSelectedFilters = state => state.returns.get('selectedReturnsFilters');
export const getSearchValues = state => state.returns.get('searchValues');
export const getSortBy = state => state.returns.get('sort');
export const getDateRange = state => state.returns.get('dateRange');
